import { React, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Grid,
  Box,
  Paper,
  useMediaQuery
} from '@material-ui/core';
import { ROUTES } from '../../../../constants/routes';
import { useHistory } from 'react-router-dom'
import ComputerIcon from '@material-ui/icons/Computer';
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import LocationOnIcon from '@material-ui/icons/LocationOn';

export default function SectionFour(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.up('md'));
  const isMobileSmall = useMediaQuery(theme.breakpoints.up('md'));
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      fontFamily: 'Raleway',
      backgroundColor: 'white'
    },
    sectionStyle: {
      backgroundColor: 'black',
      paddingLeft: 20,
      paddingRight: 20,
      fontSize: '1.2rem',
      color: 'white',
      clipPath: 'polygon(0 13%, 100% 0, 100% 100%, 0 100%)',
      webkitClipPath: 'polygon(0 13%, 100% 0, 100% 100%, 0 100%)',
    },
    sectionStyleMobile: {
      backgroundColor: 'black',
      fontSize: '.9rem',
      color: 'white',
      clipPath: 'polygon(0 13%, 100% 0, 100% 100%, 0 100%)',
      webkitClipPath: 'polygon(0 13%, 100% 0, 100% 100%, 0 100%)',
    },
    innerGridContainer: {
      width: "100%",
      margin: "0px",
      paddingBottom: '80px'
    },
    innerGridSmallHeading: {
      width: "100%",
      textAlign: "center",
      fontSize: "1rem",
      fontWeight: "bold",
      fontFamily: "sans-serif",
      marginTop: '60px'
    },
    innerGridHeading: {
      width: "100%",
      textAlign: "center",
      fontSize: "3rem",
      fontFamily: "sans-serif",
      marginTop: '60px'
    },
    sectionParagraph: {
      fontSize: ".6rem",
      marginTop: '0px',
      fontWeight: 'bold'
    },
    media: {
      maxHeight: 300,
      maxWidth: 700,
      minHeight: 300,
      float: 'right',
      width: '100%'
    },
    contentInnerGrid: {
      marginTop: '50px'
    },
    icon: {
      color: '#CB6800',
      fontSize: '50px'
    },
    iconText: {
      paddingLeft: '10px',
      fontSize: '10px',
      width: '170px'
    }
  }));

  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      <section className={isMobile ? classes.sectionStyle : classes.sectionStyleMobile}>
        <Grid container direction="row" justify="center" alignItems="center">
          <h5 className={classes.innerGridHeading} >
            <p style={{
              fontWeight: "200", fontSize: '25px'
            }}>Lad os arbejde sammen!</p>
          </h5>
          <p className={classes.sectionParagraph}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          </p>
        </Grid>
        <Grid className={classes.innerGridContainer} container direction="row" justify="center" alignItems="center">
          <Grid xs={1} >
          </Grid>
          <Grid container xs={2} className={classes.contentInnerGrid}>
            <Grid>
              <RecordVoiceOverIcon className={classes.icon} />
            </Grid>
            <Grid className={classes.iconText}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur in est vel nulla varius aliquet aliquet ac ante. Ut nibh urna, posuere et risus vel, sagittis interdum diam. Nulla vitae luctus metus.
            </Grid>
          </Grid>
          <Grid xs={1} >
          </Grid>
          <Grid container xs={2} className={classes.contentInnerGrid}>
            <Grid>
              <LocationOnIcon className={classes.icon} />
            </Grid>
            <Grid className={classes.iconText}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur in est vel nulla varius aliquet aliquet ac ante. Ut nibh urna, posuere et risus vel, sagittis interdum diam. Nulla vitae luctus metus.
            </Grid>
          </Grid>
          <Grid xs={1} >
          </Grid>
          <Grid container xs={2} className={classes.contentInnerGrid}>
            <Grid>
              <LaptopMacIcon className={classes.icon} />
            </Grid>
            <Grid className={classes.iconText}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur in est vel nulla varius aliquet aliquet ac ante. Ut nibh urna, posuere et risus vel, sagittis interdum diam. Nulla vitae luctus metus.
            </Grid>
          </Grid>
          <Grid xs={1} >
          </Grid>
        </Grid>
        
      </section>
    </div >
  )
}